import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink, Route, Switch, useHistory, withRouter} from 'react-router-dom';
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import ResourceContent from "../../../components/resource/front/detail/content";
import ResourceSide from "../../../components/resource/front/detail/side";
import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/resources";
import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";

import {BASE_PATH} from "../../../wpconfig";

class Resource extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'resource'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		this.getDetail();
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		}
	}

	getDetail() {
		func.getData(this.state.action + "/" + func.getParams("record_id"), null).then((response) => {
			if (!this.state.isInit) {
				this.setState({
					isInit: true,
				})
			}
			this.props.dataActions.setResource(response);
		});
	}

	render() {
		// const record = this.props.record;
		// console.log(record);
		// console.log(this)
		return (
			<>
				{!this.state.isInit ? <Loading/> :
					<div className="contents-group">
						<ResourceContent/>
						<ResourceSide/>
						<div id="LineChartToolTip" className="line-chart-tooltip"/>
					</div>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.resources.record ? state.resources.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Resource)

Resource.propTypes = {
	record: PropTypes.object,
	// records : PropTypes.array,
	// facet : PropTypes.object,
	// totalRecords : PropTypes.number,
	// totalPage : PropTypes.number,
};
